<template>
  <div id="panel">
    <div class="panel-header">
      <a href="#" class="logo-link" @click="goToFirstLevel">
        <div class="logo-container" v-html="logo"></div>
      </a>
      <button class="button" @click="openPanel" v-if="!panel">
        <svg class="icon icon-menu" aria-hidden="true" role="img">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-menu"></use>
        </svg>
        Menu
      </button>
      <button class="button" @click="closePanel" v-if="panel">
        <svg class="icon icon-close" aria-hidden="true" role="img">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close"></use>
        </svg>
      </button>
    </div>

    <transition name="slideIn">
      <div class="panel-aside panel-aside--parent" v-show="panel">
        <div class="logo-container" v-html="logo"></div>
        <div class="site-slogan"> {{ slogan }} </div>
        <!-- <div class="panel-aside__title">Plans interactifs</div> -->
        <search></search>
        <ul class="panel-aside__main-nav">
          <li>
            <a href="#" @click="openPanel('place')">
              <span class="item__name">Lieux</span>
              <div class="item__next">
                <svg class="icon icon-arrow-right" aria-hidden="true" role="img">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use>
                </svg>
                <span class="nb">{{ catsNb }}</span>
              </div>
            </a>
          </li>
          <li>
            <a href="#" @click="openPanel('map')">
              <span class="item__name">Plans</span>
              <div class="item__next">
                <svg class="icon icon-arrow-right" aria-hidden="true" role="img">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use>
                </svg>
                <span class="nb">{{ mapsNb }}</span>
              </div>
            </a>
          </li>
          <li>
            <a href="#" @click="openPanel('settings')" >
              <span class="item__name">Paramètres</span>
              <div class="item__next">
                <svg class="icon icon-arrow-right" aria-hidden="true" role="img">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use>
                </svg>
              </div>
            </a>
          </li>
        </ul>

        <ul class="panel-aside__footer-nav">
          <li v-for="page in pages">
            <a :href="page.href" :target="page.target"> {{ page.title }} ></a>
          </li>
        </ul>
      </div>
    </transition>

    <transition name="slideIn">
      <div class="panel-aside panel-aside--child" v-if="level === 2 && levelName === 'place'">
        <!-- <div class="panel-aside__title">Plans interactifs</div> -->
        <search></search>
        <a href="#" class="panel-prev" @click="closeChildPanel">
          <svg class="icon icon-arrow-left" aria-hidden="true" role="img">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use>
          </svg>
          Lieux
        </a>
        <ul class="panel-aside__main-nav">
          <li v-for="cat in cats">
            <a href="#" @click="showItems(cat.name, cat.id)" >
              <span class="item__name">{{cat.name}}</span>
              <div class="item__next">
                <svg class="icon icon-arrow-right" aria-hidden="true" role="img">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use>
                </svg>
                <span class="nb">{{ cat.count }}</span>
              </div>
            </a>
          </li>
        </ul>
      </div>

       <div class="panel-aside panel-aside--child" v-if="level >= 2 && levelName === 'map'">
        <!-- <div class="panel-aside__title">Plans interactifs</div> -->
        <search></search>
        <a href="#" class="panel-prev" @click="closeChildPanel">
          <svg class="icon icon-arrow-left" aria-hidden="true" role="img">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use>
          </svg>
          <span v-if="level === 2">Plans</span>
          <span v-if="level > 2">{{ parentMapName }}</span>
        </a>
        <button class="button button-show button-map" @click="closePanel" v-if="mapsId.length > 0">
          <svg class="icon icon-eye" aria-hidden="true" role="img">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-eye"></use>
          </svg>
          <div v-if="mapResultBtn">
            <span v-if="mapsId.length === 1">Afficher ce plan sur la carte</span>
            <span v-else>Afficher ces plans sur la carte</span>
          </div>
        </button>
        <ul class="panel-aside__main-nav">
          <li class="item-map" v-for="map in maps">
            <div class="child__wrapper" v-if="!map.has_children">
              <input type="checkbox" name="map" :value="map.id" :id="`map-${map.id}`" v-model="mapsId" @change="displayMapsElements">
              <label :for="`map-${map.id}`">{{map.name}}</label>
            </div>
            <div class="parent__wrapper" v-else>
              <a href="#" @click="showMaps(map.name, map.id)" >
               <span class="item__name">{{map.name}}</span>
               <div class="item__next">
                 <svg class="icon icon-arrow-right" aria-hidden="true" role="img">
                   <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use>
                 </svg>
                 <span class="nb">{{ map.count }}</span>
               </div>
              </a>
            </div>
          </li>
        </ul>
      </div>

      <div class="panel-aside panel-aside--child" v-if="level === 2 && levelName === 'settings'">
        <!-- <div class="panel-aside__title">Plans interactifs</div> -->
        <search></search>
        <a href="#" class="panel-prev" @click="closeChildPanel">
          <svg class="icon icon-arrow-left" aria-hidden="true" role="img">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use>
          </svg>
          Paramètres
        </a>
        <div class="settings__tools">
          <div class="tool__title">
            <span>Outils</span>
          </div>
          <ul>
            <li>
              <button @click="proximityClick">
                <svg class="icon icon-map" aria-hidden="true" role="img">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-map"></use>
                </svg>
                A proximité
              </button>
            </li>
            <li>
              <button @click="rangeClick">
                <svg class="icon icon-pin" aria-hidden="true" role="img">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-pin"></use>
                </svg>
                Calcul de distance
              </button>
            </li>
            <li>
              <button @click="routeClick">
                <svg class="icon icon-compass" aria-hidden="true" role="img">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-compass"></use>
                </svg>
                Itinéraire
              </button>
            </li>
          </ul>
        </div>
        <div class="render__tools">
          <div class="tool__title">
            <span>Rendu</span>
          </div>
          <ul>
            <li><button @click="changeMapRender('plan')">Plan</button></li>
            <li><button @click="changeMapRender('relief')">Relief</button></li>
            <li><button @click="changeMapRender('sat')">Satellite</button></li>
            <li><button @click="changeMapRender('mixte')">Mixte</button></li>
          </ul>
        </div>
      </div>

      <div class="panel-aside panel-aside--child" v-if="level === 2 && levelName === 'search'">
        <!-- <div class="panel-aside__title">Plans interactifs</div> -->
        <search></search>
        <a href="#" class="panel-prev" @click="closeChildPanel">
          <svg class="icon icon-arrow-left" aria-hidden="true" role="img">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use>
          </svg>
          {{ keyword }}
        </a>
        <button class="button button-show button-places" @click="displayAllMarkerOnMap(items)" v-if="items.length > 0">
          <svg class="icon icon-eye" aria-hidden="true" role="img">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-eye"></use>
          </svg>
          Afficher ces lieux sur la carte
        </button>
        <span class="error" v-if="items.length === 0">Aucun résultat avec le mot clé {{ keyword }}</span>
        <ul class="panel-aside__main-nav">
          <div v-show="isLoading" class="panel-aside__loader"></div>
          <li v-for="item in items">
            <a v-if="item.type === 'category'" href="#" @click="showItems(item.name, item.id)" >
              <span class="item__name">{{item.name}}</span>
              <div class="item__next">
                 <svg class="icon icon-arrow-right" aria-hidden="true" role="img">
                   <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use>
                 </svg>
                <span class="nb">{{ item.count }}</span>
              </div>
            </a>
            <a v-else href="#" @click="getPlaceInfo(item.id)" >
             <img v-if="item.icon" class="place-icon" :src="item.icon" alt="">
             <img v-else class="place-icon" :src="iconUrl" alt="">
              {{item.name}}
            </a>
          </li>
        </ul>
      </div>

      <div class="panel-aside panel-aside--child" v-if="level >= 3 && levelName === 'place'">
        <!-- <div class="panel-aside__title">Plans interactifs</div> -->
        <search></search>
        <a href="#" class="panel-prev" @click="closeChildPanel">
          <svg class="icon icon-arrow-left" aria-hidden="true" role="img">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use>
          </svg>
          {{ parentName }}
        </a>
        <div class="button__wrapper" v-if="resultBtn">
          <button class="button button-show hide-xs" @click="displayAllMarkerOnMap(items)">
            <svg class="icon icon-eye" aria-hidden="true" role="img">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-eye"></use>
            </svg>
            Afficher ces lieux sur la carte
          </button>
        </div>
        <ul class="panel-aside__main-nav">
          <div v-show="isLoading" class="panel-aside__loader"></div>
          <li v-for="item in items">
            <a v-if="item.type === 'category'" href="#" @click="showItems(item.name, item.id)" >
              <span class="item__name">{{item.name}}</span>
              <div class="item__next">
                <svg class="icon icon-arrow-right" aria-hidden="true" role="img">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use>
                </svg>
                <span class="nb">{{ item.count }}</span>
              </div>
            </a>
            <a v-else href="#" @click="getPlaceInfo(item.id)" >
              <img class="place-icon" v-if="item.icon" :src="item.icon" alt="">
              <img v-else class="place-icon" :src="iconUrl" alt="">
              {{item.name}}
            </a>
          </li>
        </ul>
      </div>
    </transition>

  </div>
</template>

<script>
/* global L */
/* global cgy_vars */
/* global dataLayer */
/* eslint no-undef: "error" */
  import store from '../store/store'
  import json from '../store/jsonUrl'
  import Search from './Search'
  import _ from 'lodash'
  import omnivore from '@mapbox/leaflet-omnivore'

  export default {
    name: 'panel',
    components: {
      Search
    },
    data () {
      return {
        panel: false,
        isLoading: false,
        resultBtn: false,
        mapResultBtn: false,
        logo: cgy_vars.theme_mods.site_logo,
        iconUrl: cgy_vars.defaultMarker,
        slogan: cgy_vars.theme_mods.site_baseline,
        pages: '',
        level: 1,
        levelHistory: 1,
        levelName: '',
        parentName: '',
        history: [],
        cats: [],
        catsNb: 0,
        maps: [],
        mapsNb: 0,
        parentMapName: '',
        items: [],
        marker: '',
        kmlsArr: [],
        kmlGroup: [],
        mapsId: [],
        keyword: '',
        info: '',
        proximity: '',
        range: '',
        route: '',
        contact: '',
        strokeColor: cgy_vars.line.strokeColor,
        isEmbed: store.state.isEmbed
      }
    },
    mounted () {
      this.kmlGroup = new L.FeatureGroup()
      // Get number of categories
      this.$http.get(json.url.categories).then((response) => {
        this.cats = response.data
        store.cache.categories = this.cats
        for (let i = this.cats.length - 1; i >= 0; i--) {
          if (this.cats[i].count) {
            this.catsNb += this.cats[i].count
          }
        }
      })

      // Get number of maps
      this.$http.get(json.url.maps).then((response) => {
        this.maps = response.data
        store.cache.maps = this.maps
        this.mapsNb = this.maps.length
      })

      if (store.cache.pages) {
        this.pages = store.cache.pages
      } else {
        this.$http.get(json.url.pages).then((response) => {
          this.pages = response.data
          store.cache.pages = this.pages
        })
      }

      for (var i = 0; i < this.$parent.$children.length; i++) {
        if (this.$parent.$children[i].$options.name === 'place-info') {
          this.info = this.$parent.$children[i]
        }
        if (this.$parent.$children[i].$options.name === 'proximity') {
          this.proximity = this.$parent.$children[i]
        }
        if (this.$parent.$children[i].$options.name === 'range') {
          this.range = this.$parent.$children[i]
        }
        if (this.$parent.$children[i].$options.name === 'route') {
          this.route = this.$parent.$children[i]
        }
        if (this.$parent.$children[i].$options.name === 'contact') {
          this.contact = this.$parent.$children[i]
        }
      }
    },
    watch: {
      keyword: function (val) {
        this.items = store.cache.search[this.keyword]
      }
    },
    methods: {
      /**
       * Open parent panel
       */
      openPanel: function (name) {
        if (!this.panel) {
          if (store.state.isMobile) {
            this.panel = true
          }
          this.level = this.levelHistory
          this.handlePanelBodyClass(this.panel)
          this.closeChildComponents()
        } else {
          this.level++
          this.levelHistory++
          this.levelName = name
        }
      },
      /**
       * Close parent panel
       */
      closePanel: function () {
        if (store.state.isMobile) {
          this.panel = false
        }
        this.level = 1
        this.handlePanelBodyClass(this.panel)
      },
      /**
       * Close current child panel
       */
      closeChildPanel: function () {
        this.level--
        this.levelHistory--
        if (this.level > 2) {
          // Get last ID panel from history
          let i = this.history.length - 2
          let id = this.history[i].id
          this.parentName = this.history[i].name
          // Delete last history entry
          this.history.pop()
          // Do a req
          if (this.levelName === 'place') {
            this.doCategoryReq(id, this.displayResultBtn)
          } else if (this.levelName === 'map') {
            this.doMapChildReq(id, this.displayResultBtn)
          }
        } else {
          if (this.levelName === 'map') {
            this.doMapChildReq(null, this.displayResultBtn)
          }
          // Reset history
          this.history = []
        }
      },
      closeChildComponents: function () {
        this.proximity.closeProximity()
        this.info.closePlaceInfo()
        this.route.closeRoute()
        this.range.closeRange()
      },
      /**
       * Add or remove opened class on body
       */
      handlePanelBodyClass: function (state) {
        // Add or remove opened class to panel
        let body = document.querySelectorAll('body')[0]
        if (state) {
          body.classList.add('panel-opened')
        } else {
          body.classList.remove('panel-opened')
        }
      },
      /**
       * Back to first level on logo click
       */
      goToFirstLevel: function () {
        this.level = 1
        this.levelHistory = 1
        this.openPanel()
      },
      /**
       * Display items for the selected panel entry
       * @param  {String} name
       * @param  {Int} id
       */
      showItems: function (name, id) {
        // Increase level panel
        this.level++
        this.levelHistory++
        // Build history panel
        this.buildPanelHistory(name, id)
        // Set parent name
        this.parentName = name
        // Do req
        this.doCategoryReq(id, this.displayResultBtn)
      },
      showMaps: function (name, id) {
        // Increase level panel
        this.level++
        this.levelHistory++
        // Build history panel
        this.buildPanelHistory(name, id)
        // Set parent name
        this.parentMapName = name
        // Do req
        this.doMapChildReq(id, this.displayMapResultBtn)
      },
      /**
       * Handle request for the place category
       * @param  {Int} id
       */
      doCategoryReq: function (id, callback) {
        // Check if datas are already stored
        if (store.cache.category[id] && store.cache.activate) {
          this.items = store.cache.category[id]
          if (callback !== null) {
            callback()
          }
        } else {
          this.isLoading = true
          this.$http.get(`${json.url.category}&id=${id}`).then((response) => {
            this.items = response.data
            store.cache.category[id] = response.data
          }, (response) => {
            console.log('error', response)
          }).then(_ => {
            this.isLoading = false
            if (callback !== null) {
              callback()
            }
          })
        }
      },
      doMapChildReq: function (id, callback) {
        // Check if datas are already stored
        if (id === null) {
          this.maps = store.cache.maps
        } else {
          if (store.cache.mapsChild[id] && store.cache.activate) {
            this.maps = store.cache.mapsChild[id]
            if (callback !== null) {
              callback()
            }
          } else {
            this.isLoading = true
            this.$http.get(`${json.url.maps}&id=${id}`).then((response) => {
              this.maps = response.data
              store.cache.mapsChild[id] = response.data
            }, (response) => {
              console.log('error', response)
            }).then(_ => {
              this.isLoading = false
              if (callback !== null) {
                callback()
              }
            })
          }
        }
      },
      /**
       * Show or Hide view all places on map button
       */
      displayResultBtn: function () {
        for (let i = 0; i < this.items.length; i++) {
          this.resultBtn = false
          if (this.items[i].type !== 'category') {
            this.resultBtn = true
            this.displayAllMarkerOnMap(this.items)
            return
          }
        }
      },
      displayMapResultBtn: function () {
        for (let i = 0; i < this.maps.length; i++) {
          this.mapResultBtn = false
          if (!this.maps[i].has_children) {
            this.mapResultBtn = true
            this.displayMapsElements()
            return
          }
        }
      },
      /**
       * Store a panel history for the back button behavior
       * @param  {String} name
       * @param  {Int} id
       */
      buildPanelHistory: function (name, id) {
        let parent = {}
        parent.name = name
        parent.id = id
        this.history.push(parent)
      },
      /**
       * Handle request for a single place
       * @param  {Int} id
       */
      getPlaceInfo: function (id) {
        if (store.cache.places[id] && store.cache.activate) {
          this.displaySingleMarkerOnMap(id, store.cache.places[id].name, store.cache.places[id].icon, store.cache.places[id].lat, store.cache.places[id].lng)
        } else {
          this.$http.get(`${json.url.place}&id=${id}`).then((response) => {
            this.displaySingleMarkerOnMap(id, response.data.name, response.data.icon, response.data.lat, response.data.lng)
            store.cache.places[id] = response.data
          }, (response) => {
            console.log('error', response)
          })
        }
      },
      /**
       * Display the single place marker
       * @param  {String} icon
       * @param  {Float} lat
       * @param  {Float} lng
       */
      displaySingleMarkerOnMap: function (id, name, icon, lat, lng) {
        // var noLayer = false
        // Remove existing single marker
        store.cache.markersGroup.clearLayers()
        // Create marker object
        this.marker = L.marker([lat, lng]).on('click', this.info.markerOnClick)
        this.marker.placeId = id
        let markerIcon
        if (icon) {
          markerIcon = store.iconOptions({
            options: {
              iconUrl: icon
            }
          })
        } else {
          markerIcon = L.icon({
            iconUrl: this.iconUrl,
            iconSize: [21, 26],
            iconAnchor: [10.5, 26]
          })
        }
        this.marker.setIcon(markerIcon)
        store.cache.markersGroup.addLayer(this.marker)
        // Center map on selected place
        this.centerMapOnMarker(this.marker)
        this.markerPopup(this.marker, name)
        // Close panel
        if (store.state.isMobile) {
          this.closePanel()
        }
        // Show marker info
        this.active = true
        this.expand = true
        this.info.getClickedMarkerData(id)
      },
      markerPopup: function (marker, name) {
        marker.bindPopup(name, {offset: new L.Point(0, -28)})
        marker.on('mouseover', function (e) {
          this.openPopup()
        })
        marker.on('mouseout', function (e) {
          this.closePopup()
        })
      },
      /**
       * Center the map on the single displayed marker
       * @param  {Object}
       */
      centerMapOnMarker: function (marker) {
        let latLngs = [ marker.getLatLng() ]
        let markerBounds = L.latLngBounds(latLngs)
        store.state.map.fitBounds(markerBounds)
      },
      /**
       * Display all markers of a category on the map
       */
      displayAllMarkerOnMap: function (places) {
        // Clear markers
        store.cache.markersGroup.clearLayers()
        if (places.length === 0) {
          return
        }
        for (let i = 0; i < places.length; i++) {
          if (!this.checkIsValidPlace(places[i])) {
            continue
          }
          // create custom icon
          let markerIcon
          if (places[i].icon) {
            markerIcon = store.iconOptions({
              options: {
                iconUrl: places[i].icon
              }
            })
          } else {
            markerIcon = L.icon({
              iconUrl: this.iconUrl,
              iconSize: [21, 26],
              iconAnchor: [10.5, 26]
            })
          }

          // create marker object, pass custom icon as option, add to map
          let marker = L.marker([places[i].lat, places[i].lng], {icon: markerIcon}).on('click', this.info.markerOnClick)
          this.markerPopup(marker, places[i].name)
          marker.placeId = places[i].id
          store.cache.markersGroup.addLayer(marker)
        }
        store.state.map.fitBounds(store.cache.markersGroup.getBounds())
        store.state.map.addLayer(store.cache.markersGroup)
        if (this.levelName !== 'map' && store.state.isMobile) {
          this.closePanel()
        }
      },
      checkIsValidPlace: function (place) {
        return (_.isNumber(+place.lat) && _.isNumber(+place.lng)) && (!_.isNaN(+place.lat) && !_.isNaN(+place.lng) && (place.lat && place.lng))
      },
      // MAPS METHODS
      displayMapsElements: function () {
        if (this.mapsId.length === 0) {
          this.displayAllMarkerOnMap([])
          this.cleanKMLUnchecked()
          return
        }
        let reqs = []
        for (let i = this.mapsId.length - 1; i >= 0; i--) {
          reqs.push(this.doMapsReq(this.mapsId[i]))
        }
        Promise.all(reqs).then(function (data) {
          let maps = []
          data.forEach(function (req) {
            req.forEach(function (el) {
              maps.push(el)
            })
          })
          return maps
        }).then(maps => {
          this.displayAllMarkerOnMap(maps)
          this.displayKMLOnMap()
        })
      },
      displayKMLOnMap: function () {
        this.cleanKMLUnchecked()
        let that = this
        let i = this.mapsId.length - 1
        let id = this.mapsId[i]

        let allMaps = store.cache.maps
        store.cache.mapsChild.forEach(item => {
          allMaps = [...allMaps, ...item]
        })
        if (!_.find(this.kmlGroup, {id: id})) {
          let map = _.find(allMaps, {id: id})
          if (map.url) {
            let kml = {}
            kml.id = map.id
            let customLayer = L.geoJson(null, {
              style: function (feature) {
                return {
                  color: that.strokeColor
                }
              }
            }, this)
            let layer = omnivore.kml(map.url, null, customLayer)
            layer.mapId = map.id
            this.kmlGroup.addLayer(layer)
            kml.layer = layer
            this.kmlsArr.push(kml)
            store.state.map.addLayer(layer)
            layer.on('ready', function () {
              store.state.map.fitBounds(this.kmlGroup.getBounds())
            }, this)
          }
        }
      },
      cleanKMLUnchecked: function () {
        let ids = []
        this.kmlsArr.forEach(function (kml) {
          ids.push(kml.id)
        })
        let diffs = _.difference(ids, this.mapsId)
        diffs.forEach(function (diff) {
          let kml = _.find(this.kmlsArr, {id: diff})
          let index = _.findIndex(this.kmlsArr, {id: diff})
          store.state.map.removeLayer(kml.layer)
          this.kmlsArr.splice(index, 1)
        }, this)
      },
      doMapsReq: function (id) {
        // Check if datas are already stored
        return new Promise((resolve, reject) => {
          if (store.cache.map[id] && store.cache.activate) {
            resolve(store.cache.map[id])
          } else {
            this.$http.get(`${json.url.map}&id=${id}`).then((response) => {
              store.cache.map[id] = response.data
              resolve(response.data)
            }, (response) => {
              reject(response)
            })
          }
        })
      },
      changeMapRender: function (type) {
        store.state.map.removeLayer(store.cache.render)
        if (type === 'plan') {
          dataLayer.push({rendu: 'Plan'})
          store.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
          })
        } else if (type === 'sat') {
          dataLayer.push({rendu: 'Satellite'})
          store.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
          })
        } else if (type === 'relief') {
          dataLayer.push({rendu: 'Relief'})
          store.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
          })
        } else if (type === 'mixte') {
          dataLayer.push({rendu: 'Mixte'})
          store.cache.render = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
          })
        } else {
          return false
        }
        store.state.map.addLayer(store.cache.render)
      },
      proximityClick: function () {
        let mapCenter = store.state.map.getCenter()
        this.closePanel()
        this.proximity.proximityOnClick(mapCenter)
      },
      rangeClick: function () {
        this.closePanel()
        this.range.rangeOnClick()
      },
      routeClick: function () {
        this.closePanel()
        this.route.routeOnClick(null)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Panel.vue?974485e6